import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const baseCls = 'react-hint__content';

export default class MobileHintContent extends PureComponent {
  constructor(props) {
    super(props);
    this.handleTouch = this.handleTouch.bind(this);
  }

  componentDidMount() {
    this.hintContainer = document.querySelector('.react-hint');
    this.hintContainer.addEventListener('touchstart', this.handleTouch);
  }

  componentWillUnmount() {
    if (this.hintContainer) {
      this.hintContainer.removeEventListener('touchstart', this.handleTouch);
    }
  }

  handleTouch(e) {
    const { onClose } = this.props;
    if (e.target === this.hintContainer) {
      onClose();
    }
  }

  get hintContainer() {
    return this._hint;
  }

  set hintContainer(element) {
    this._hint = element;
  }

  render() {
    const { children } = this.props;
    return <div className={`${baseCls}--mobile`}>{children}</div>;
  }
}

MobileHintContent.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
